import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Section } from "./_Section";
import * as yup from "yup";
import { clearMask, showToast } from "../../utils";
import { Flex, FormControl } from "@chakra-ui/react";
import { Input } from "../../components/Forms/Input";
import { useSeller } from "../../hooks/useSeller";
import { useEffect, useState } from "react";

const editAddressSchema = yup.object().shape({
  country: yup.string().required("Preenchimento obrigatório!"),
  state: yup.string().required("Preenchimento obrigatório!"),
  city: yup.string().required("Preenchimento obrigatório!"),
  district: yup.string().required("Preenchimento obrigatório!"),
  street: yup.string().required("Preenchimento obrigatório!"),
  zipCode: yup.string().required("Preenchimento obrigatório!"),
  number: yup.string().required("Preenchimento obrigatório!"),
  complement: yup.string(),
});

interface AddressSectionProps {
  id: string | undefined;
  setEdit: (name: string) => void;
  editSection: string;
  address: {
    city: string;
    complement: string;
    country: string;
    district: string;
    id: number;
    number: string;
    state: string;
    street: string;
    zipCode: string;
  };
}

export interface AddressSectionData {
  country: string;
  state: string;
  city: string;
  district: string;
  street: string;
  zipCode: string;
  number: string;
  complement: string;
}
export function AddressSection({ id, setEdit, editSection, address }: AddressSectionProps) { 

  const { patchAddress, consultCep } = useSeller();
  const [isCepLoading, setIsCepLoading] = useState(false);
  
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    setValue,
    watch,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(editAddressSchema),
  });
  
  const cep = watch("zipCode");

  function setDefaultData() {
    setValue("country", address?.country);
    setValue("state", address?.state);
    setValue("city", address?.city);
    setValue("district", address?.district);
    setValue("street", address?.street);
    setValue("number", address?.number);
    setValue("zipCode", address?.zipCode);
    setValue("complement", address?.complement);
  }

  const onSubmit = handleSubmit( async ({
    country,
    state,
    city,
    district,
    street,
    number,
    zipCode,
    complement
  }: AddressSectionData) => {
    try {
      const addressData = {
        country,
        state,
        city,
        district,
        street,
        zipCode: clearMask(zipCode),
        number,
        complement,
      }
      await patchAddress(addressData, id);
      setEdit("");
      showToast({ message: "Informações editadas com sucesso", type: "success" });
      return
      } catch (error: any) {
        setEdit("");
        error?.response?.data?.errors?.map((error: any) =>
          showToast({
            type: "error",
            message: `${error?.code} - ${error?.description}`,
          })
        );
      }
    }
  );
  async function handleGetCep() {
    try {
        clearErrors("zipCode")
        setIsCepLoading(true);
        const { data } = await consultCep(clearMask(cep));
        setValue("street", data.logradouro);
        setValue("district", data.bairro);
        setValue("city", data.localidade);
        setValue("state", data.uf);
        setValue("complement", "");
        setValue("country", "BR");
    } catch {
        if(cep.length !== 10) return setError("zipCode", { type: "custom", message:"Cep inválido."})
    } finally {
        setIsCepLoading(false);
    }
  }
  useEffect(() => {
    setDefaultData();
    //eslint-disable-next-line
  }, [])
  return (
    <Section
      sectionTitle="Endereço"
      isEdit={editSection === "address"}
      onClickEditButton={() => {
        setEdit("address");
      }}
      onClickConfirmButton={onSubmit}
    >
      <Flex gap={4}>
        <FormControl maxWidth="280px">
          <Input
            label="Código Postal"
            defaultValue={address?.zipCode}
            name="zipCode"
            maxLength={10}
            p="0"
            register={{ ...register("zipCode") }}
            onBlur={handleGetCep}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            mask="cep"
            isDisabled={editSection !== "address"}
            errors={errors?.zipCode}
          />
        </FormControl>
        <FormControl maxWidth="280px">
          <Input
            label="Rua/Avenida"
            defaultValue={address?.street}
            name="street"
            p="0"
            register={{ ...register("street") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "address" || isCepLoading}
            errors={errors?.street}
          />
        </FormControl>

        <FormControl maxWidth="280px">
          <Input
            label="Número"
            defaultValue={address?.number}
            name="number"
            p="0"
            register={{ ...register("number") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "address"}
            errors={errors?.number}
          />
        </FormControl>
        <FormControl maxWidth="280px">
          <Input
            label="Complemento"
            defaultValue={address?.complement}
            name="complement"
            p="0"
            register={{ ...register("complement") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "address"}
            errors={errors?.complement}
          />
        </FormControl>
      </Flex>
      <Flex gap={4}>
        <FormControl maxWidth="280px">
          <Input
            label="Bairro"
            defaultValue={address?.district}
            name="district"
            p="0"
            register={{ ...register("district") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "address" || isCepLoading}
            errors={errors?.transparent}
          />
        </FormControl>
        <FormControl maxWidth="280px">
          <Input
            label="Cidade"
            defaultValue={address?.city}
            name="city"
            p="0"
            register={{ ...register("city") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "address" || isCepLoading}
            errors={errors?.city}
          />
        </FormControl>
        <FormControl maxWidth="280px">
          <Input
            label="Estado"
            defaultValue={address?.state}
            name="state"
            p="0"
            register={{ ...register("state") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "address" || isCepLoading}
            errors={errors?.state}
          />
        </FormControl>
        <FormControl maxWidth="280px">
          <Input
            label="País"
            defaultValue={address?.country}
            name="country"
            p="0"
            register={{ ...register("country") }}
            _disabled={{
              bg: "transparent",
              border: "none",
            }}
            isDisabled={editSection !== "address" || isCepLoading}
            errors={errors?.country}
          />
        </FormControl>
      </Flex>
    </Section>
  );
}